module.exports = __webpack_public_path__ + "img/device.f09c5c33.png";